import { z } from 'zod';

export interface CommentItem {
  startTime: number;
  endTime: number;
  audioUrl: string;
  audioDuration?: number;
}

export type VideoCommentaryProps = Record<string, unknown> & {
  backgroundVideo: {
    url: string;
    duration?: number | null | undefined;
    width?: number | null | undefined;
    height?: number | null | undefined;
    fps?: number | null | undefined;
  };
  render?: {
    width?: number | null | undefined;
    height?: number | null | undefined;
  };
  comments: CommentItem[];
  voiceVolume: number;
  originalVolume: number;
  fastForwardSpeed?: number;
};

export const videoCommentarySchema = z.object({
  backgroundVideo: z.object({
    url: z.string().min(1),
    duration: z.number().min(0).nullable().optional(),
    width: z.number().positive().nullable().optional(),
    height: z.number().positive().nullable().optional(),
    fps: z.number().positive().nullable().optional(),
  }),
  render: z
    .object({
      width: z.number().positive().nullable().optional(),
      height: z.number().positive().nullable().optional(),
    })
    .optional(),
  comments: z.array(
    z.object({
      startTime: z.number().min(0),
      endTime: z.number().min(0),
      audioUrl: z.string().min(1),
      audioDuration: z.number().min(0).optional(),
    }),
  ),
  voiceVolume: z.number().min(0).max(100),
  originalVolume: z.number().min(0).max(100),
  fastForwardSpeed: z.number().min(1).max(8).optional(),
});
